export default "__VITE_ASSET__0CIj_ehj__"